import { avatarsRaw } from "../utils/avatars";

export const generateRandomAvatar =
  avatarsRaw[Math.floor(Math.random() * avatarsRaw.length)];
